import {HasData, SignalEventsSummary, Trend} from 'gabi-api-ts/v2/signal/query/signal_query';

export const defaultSignalEventsSummary: SignalEventsSummary = {
    trend: Trend.NO_DATA,
    events: {
        value: 0,
        hasData: HasData.HAS_NO_DATA
    },
    eventsPrevious: {
        value: 0,
        hasData: HasData.HAS_NO_DATA
    },
};
